<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="create-article-flag-schedule-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Create Schedule
            </h4>
          </div>

          <div v-if="!loading" class="modal-body">
            <DateFormGroup
                v-model="data.starts_at"
                name="starts_at"
                label="Starts At"
                help-text="The time that the schedule starts."
                :error="(errors.starts_at || [])[0]"
                format="YYYY-MM-DD HH:mm:ss"
                original-format="YYYY-MM-DD HH:mm:ss"
            />

            <DateFormGroup
                v-model="data.ends_at"
                name="ends_at"
                label="Ends At"
                help-text="The time that the schedule ends."
                :error="(errors.ends_at || [])[0]"
                format="YYYY-MM-DD HH:mm:ss"
                original-format="YYYY-MM-DD HH:mm:ss"
            />

            <SelectFormGroup
                v-model="data.content_article_flag_id"
                name="content_article_flag_id"
                label="Flag"
                help-text="The flag to schedule."
                :error="(errors.content_article_flag_id || [])[0]"
                :options="contentArticleFlagOptions"
            />

            <TypeaheadFormGroup
                v-model="data.content_article_id"
                name="content_article_id"
                label="Article"
                :error="(errors.content_article_id || [])[0]"
                endpoint="/api/v2/content-articles"
                :params="{'filter[portal_id]': portal.id}"
                :token="shared.token"
                path="data.data"
                placeholder="Search..."
                :result-label-property="row => row.attributes.title"
                help-text="The article to schedule."
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import store from '@/store'
import DateFormGroup from '@/vendor/forms/FormGroups/Block/Date'
import Errors from '@/mixins/Errors'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import TypeaheadFormGroup from '@/vendor/forms/FormGroups/Block/Typeahead'

export default {
  components: {DateFormGroup, SelectFormGroup, TypeaheadFormGroup},

  mixins: [Errors],

  props: {
    portal: {
      type: Object
    },

    from: {
      type: String
    },

    to: {
      type: String
    }
  },

  data() {
    return {
      data: {
        starts_at: this.from,
        ends_at: this.to
      },

      flags: null,

      shared: store,
      loading: true
    }
  },

  watch: {
    from() {
      this.data.starts_at = this.from
    },

    to() {
      this.data.ends_at = this.to
    },
  },

  mounted() {
    this.listenForClose()

    this.load()
  },

  computed: {
    contentArticleFlagOptions() {
      return this.flags.map(flag => ({value: flag.id, label: flag.attributes.name}))
    }
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    load() {
      http.get('/api/v2/content-article-flags', {'filter[portal_id]': this.portal.id}).then(response => {
        this.flags = response.data.data

        this.loading = false
      })
    },

    submit() {
      http.post('/api/v2/content-article-flag-schedules', this.data)
          .then(response => {
            this.$emit('created', response.data.data)

            notify.success('The schedule was saved.')

            $(this.$el).modal('hide')
          })
          .catch(this.catchValidationErrors)

    },

    reset() {
      this.errors = {}

      this.data = {
        starts_at: this.from,
        ends_at: this.to
      }
    }
  }
}
</script>
